import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsumptionInvoicesState } from '@store/states/consumption-invoices.state';

const consumptionInvoicesFeatureSelector = createFeatureSelector<ConsumptionInvoicesState>('consumptionInvoices');

export const consumptionInvoicesSelectors = {
  requestList: createSelector(consumptionInvoicesFeatureSelector, (state) => state.requestList.data),
  requestListError: createSelector(consumptionInvoicesFeatureSelector, (state) => state.requestList.error),
  requestListFilter: createSelector(consumptionInvoicesFeatureSelector, (state) => state.requestList.filter),
  requestListPage: createSelector(consumptionInvoicesFeatureSelector, (state) => state.requestList.page),
  requestListSort: createSelector(consumptionInvoicesFeatureSelector, (state) => state.requestList.sort),
  informesUser: createSelector(consumptionInvoicesFeatureSelector, (state) => state.informesUser.data),
  informesUserError: createSelector(consumptionInvoicesFeatureSelector, (state) => state.informesUser.error),
  currentTab: createSelector(consumptionInvoicesFeatureSelector, (state) => state.currentTab),
  tabs: createSelector(consumptionInvoicesFeatureSelector, (state) => state.tabs),
  currentTabIndex: createSelector(consumptionInvoicesFeatureSelector, (state) => state.tabs.indexOf(state.currentTab)),
  acsFilter: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.graphs?.acs?.filter),
  acsGraphType: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.graphs?.acs?.graphType),
  acsData: createSelector(consumptionInvoicesFeatureSelector, (state) => {
    const previousData = state?.graphs?.acs?.previousData;
    const currentData = state?.graphs?.acs?.currentData;
    if (!!previousData || !!currentData) {
      return { previousData, currentData };
    }
    return null;
  }),
  climateFilter: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.graphs?.climate?.filter),
  climateGraphType: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.graphs?.climate?.graphType),
  climateError: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.graphs?.climate?.error),
  climateData: createSelector(consumptionInvoicesFeatureSelector, (state) => {
    const previousData = state?.graphs?.climate?.previousData;
    const currentData = state?.graphs?.climate?.currentData;
    if (!!previousData || !!currentData) {
      return { previousData, currentData };
    }
    return null;
  }),
  housingAcs: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.housingAcs),
  roomsAcs: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.roomsAcs),
  housingClimate: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.housingClimate),
  roomsClimate: createSelector(consumptionInvoicesFeatureSelector, (state) => state?.roomsClimate),
};
